import React from 'react';

import './CardStats.scss';
import iconAgree from '../../../../styles/assets/icons/agree.svg'
import iconDisagree from '../../../../styles/assets/icons/disagree.svg'
import iconComments from '../../../../styles/assets/icons/comments.svg'

import { Plate } from '../../../basic/Plate/Plate';
import { abbreviateNumber } from '../../../../utils/numbers';

interface ICardStatsProps {
  likes: number;
  dislikes: number;
  comments?: number;
  hideComments?: boolean;
}

export function CardStats({ likes, dislikes, comments, hideComments }: ICardStatsProps) {
  const renderCounter = ({ icon, value }: { icon: any, value: number }) =>
    (
      <li className='CardStats__counter'>
        <div className='CardStats__icon-number-group'>
          <img className='CardStats__icon' src={ icon } alt='icon' />
          <span className='CardStats__number'>
            { abbreviateNumber(value) }
          </span>
        </div>
      </li>
    );
  return (
    <div className='CardStats'>
      <Plate doNotCompensateBottom={true}> 
        <ul className='CardStats__list'>
          { renderCounter({ icon: iconAgree, value: likes }) }
          { renderCounter({ icon: iconDisagree, value: dislikes }) }

          {
            hideComments
              ? null
              : (
                <li className='CardStats__counter'>
                  <div className='CardStats__icon-number-group'>
                    <img className='CardStats__icon CardStats__icon-comments' src={ iconComments } alt='comment-icon' />
                    <span className='CardStats__number'>
                      { comments ? abbreviateNumber(comments): 0 }
                    </span>
                  </div>
                </li>
              )
          }
          
        </ul>
      </Plate>
    </div>
  );
}
